// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"ce69831e","787":"128fc6e9"}[chunkId] + ".chunk.js";
};